import React from 'react'
import { Box, makeStyles, Typography, Grid } from '@material-ui/core'
import PropTypes from 'prop-types'

const useStyles = makeStyles(theme => ({
    root: {
        color: '#ededed!important'
    },
    pageBackground: {
        height: 350,
        marginTop: -300,
        background: 'url(/img/bg-clipped.png)',
        backgroundSize: 'contain',
        backgroundRepeat: 'no-repeat',
        backgroundPosition: 'center bottom'
    },
    upperSection: {
        background: '#15181a',
        padding: theme.spacing(8, 0, 6, 0)
    },
    lowerSection: {
        background: '#1d2124',
        padding: theme.spacing(4, 0, 3, 0),
        '& a': {
            marginRight: theme.spacing(2)
        }
    },
    wrapper: {
        padding: theme.spacing(0, 2),
        maxWidth: '76.875rem',
        margin: 'auto'
    },
    logoWrapper: {},
    logo: {
        maxWidth: '100%',
        width: 245
    },
    headerWrapper: {
        float: 'left',
        width: '100%'
    },
    header: {
        textAlign: 'left!important',
        color: 'white!important',
        borderBottom: '3px solid ' + theme.palette.primaryColor,
        paddingBottom: theme.spacing(0.5),
        marginBottom: theme.spacing(2),
        float: 'left',
        fontSize: '1.3125rem!important',
        marginTop: theme.spacing(0.5) + '!important'
    },
    content: {
        color: '#ededed!important',
        marginBottom: theme.spacing(2),
        '& a': {
            color: theme.palette.primaryColor + '!important',
            textDecoration: 'none'
        }
    }
}))

function Footer({ className, children, icon, ...rest }) {
    const classes = useStyles()
    return (
        <Box className={classes.root}>
            <Box className={classes.upperSection}>
                <Box className={classes.wrapper}>
                    <Grid container spacing={2} className={classes.container}>
                        <Grid item md={7}>
                            <Box className={classes.logoWrapper} mb={4}>
                                <img src="/img/leadspark-logo-valkoinen.png" className={classes.logo} />
                            </Box>
                            <Box>
                                <Typography variant="body1" className={classes.content}>
                                    Kilpailu.fi on 100% suomalainen kilpailu- ja arvontasivusto, joka jakaa kanssasi Suomen reiluimmat lahjakortit ja
                                    palkinnot.
                                </Typography>
                                <Typography variant="body1" className={classes.content}>
                                    Kilpailuun osallistuminen on aina ilmaista etkä sitoudu mihinkään. Kilpailu.fi tai yhteistyökumppanimme maksaa
                                    palkinnot voittajille, kampanjasta riippuen.
                                </Typography>
                                <Typography variant="body1" className={classes.content}>
                                    Voittaja arvotaan kilpailun päätyttyä. Voittajaan ollaan yhteydessä sähköpostitse ja puhelimitse. Kun voittaja on arvottu ja palkinto lähtenyt maksuun, laitamme voittajan etunimen esille Kilpailu.fi:n sivuille.
                                </Typography>
                                <Typography variant="body1" className={classes.content}>
                                    Kilpailu.fi:n takana on kotimainen teknologiayritys LeadSpark Oy, joka on rekisteröity kaupparekisteriin
                                    Y-tunnuksella 2775435-5.
                                </Typography>
                            </Box>
                        </Grid>
                        <Grid item md={1} />
                        <Grid item md={4}>
                            <Box mb={4}>
                                <Box className={classes.headerWrapper}>
                                    <Typography variant="h4" className={classes.header}>
                                        Asiakaspalvelu
                                    </Typography>
                                </Box>
                                <Typography variant="body1" className={classes.content}>
                                    Palvelemme arkisin klo 9-17.
                                </Typography>
                                <Typography variant="body1" className={classes.content}>
                                    Tavoitat meidät sähköpostitse{' '}
                                    <a target="_blank" href="mailto:info@kilpailu.fi">
                                        info@kilpailu.fi
                                    </a>
                                    .
                                </Typography>
                            </Box>
                            <Box>
                                <Box className={classes.headerWrapper}>
                                    <Typography variant="h4" className={classes.header}>
                                        Tietosuoja ja ehdot
                                    </Typography>
                                </Box>
                                <Typography variant="body1" className={classes.content}>
                                    Voit tutustua palvelumme tietosuoja- ja evästekäytäntöihin sekä käyttöehtoihin.
                                </Typography>
                                <Typography variant="body1" className={classes.content}>
                                    <a target="_blank" href="https://www.kilpailu.fi/tietosuoja">
                                        Tietosuojaseloste
                                    </a>{' '}
                                    ja{' '}
                                    <a target="_blank" href="https://www.kilpailu.fi/ehdot.html">
                                        käyttöehdot
                                    </a>
                                    .
                                </Typography>
                            </Box>
                        </Grid>
                    </Grid>
                </Box>
            </Box>
            <Box className={classes.lowerSection}>
                <Box className={classes.wrapper}>
                    <Grid container spacing={2} className={classes.container}>
                        <Grid item md={8}>
                            <Typography variant="body1" className={classes.content}>
                                <a target="_blank" href="https://www.leadspark.fi/">
                                    LeadSpark.fi
                                </a>{' '}
                                <a target="_blank" href="https://www.kilpailu.fi">
                                    Kilpailu.fi
                                </a>{' '}
                                <a target="_blank" href="https://www.kilpailu.fi/fi/voittajat/">
                                    Voittajat
                                </a>{' '}
                                <a target="_blank" href="https://www.kilpailu.fi/fi/ukk/">
                                    Usein kysytyt kysymykset
                                </a>
                            </Typography>
                        </Grid>
                        <Grid item md={4}>
                            <Typography variant="body1" className={classes.content}>
                                © LeadSpark, All Rights Reserved
                            </Typography>
                        </Grid>
                    </Grid>
                </Box>
            </Box>
        </Box>
    )
}

Footer.propTypes = {
    className: PropTypes.string
}

export default Footer
